import { ReactElement } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { useSessionScope } from 'services';

export function EnterpriseLink({ to, ...props }: NavLinkProps): ReactElement {
  const { slug } = useSessionScope();
  return <NavLink to={typeof to === 'string' && to.startsWith('/') ? `/${slug}${to}` : to} {...props} />;
}
